import { Component, OnInit, Input } from '@angular/core';
import { OfficeStatus } from '../../../../../../shared/office-status';
import { FruHttpService } from '../../../../../../services/fru-http.service';
import { BrandService, FREERATEUPDATE_LOGO_SVG } from '../../../../../../services/brand.service';

@Component({
    selector: 'app-form-landing-header',
    templateUrl: './form-landing-header.component.html',
    styleUrls: ['./form-landing-header.component.scss'],
    standalone: false
})
export class FormLandingHeaderComponent implements OnInit {
  officeStatus: OfficeStatus;
  readonly corporateLogoSrc = FREERATEUPDATE_LOGO_SVG;

  constructor(
    private fruHttp: FruHttpService,
    public brandService: BrandService,
  ) { }

  get corporateBrandOnly(): boolean {
    return this.brandService.domain === 'freerateupdate.com';
  }

  get coBrandLogoSrc(): string {
    const logoSrc = this.brandService.logoSrc;
    return [
      this.corporateLogoSrc,
      '/assets/images/logo.png',
      '/assets/images/fru-logo.svg',
    ].indexOf(logoSrc) >= 0 ? '' : logoSrc;
  }

  ngOnInit() {
  }

  adDisclosurePopup() {
    this.fruHttp.adDisclosurePopup();
  }

}
